// firebase.js
import { initializeApp } from "firebase/app";
import { FacebookAuthProvider, getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC9B-WnW2iaBJ2ai40OcwOPrXj1fLpr3QA",
  authDomain: "your-friend-my-friend.firebaseapp.com",
  projectId: "your-friend-my-friend",
  storageBucket: "your-friend-my-friend.firebasestorage.app",
  messagingSenderId: "721637020428",
  appId: "1:721637020428:web:59e08dea4945b476ab2f29"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
// auth.settings.appVerificationDisabledForTesting = true;
// auth.languageCode = 'en'; // optional
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider()
export { auth, googleProvider, facebookProvider };
